const e = /* @__PURE__ */ Symbol("collapseContextKey");
export {
  e as collapseContextKey
};
